import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";


import AmenityInfo from "./components/amenityInfo";
import AmenityMedia from "./components/aminetyMedia";
import AmenityPricing from "./components/amenityPricing";
import AmenityInsertReview from "./components/amenityInsertReview";
import AmenityTiming from "./components/amenityTiming";
import AmenityTimingWeekDay from "./components/amenityTimingWeekDay";
import AmenityQuestions from "../questions";
import AmenityComment from "../comments";

import { v4 as uuidv4 } from 'uuid';
import AmenitiesService, { uploadImage } from "../../../../services/amenities.service";

import { useEffect } from "react";

import MDSnackbar from "../../../../components/MDSnackbar";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { useLocation, useNavigate } from "react-router-dom";
import CheckoutForm from "../payment/CheckoutForm";
function getSteps() {
  // return ["1. Product Info", "2. Media", "3. Pricing", "4. WeekDay", "5. Timing", "6. Questions", "7. Ads", "8. Review"];
  return ["1. Info", "2. Media", "3. Pricing", "4. WeekDay", "5. Timing", "6. Questions"];
}

function InsertAmenity() {

  const search = useLocation().search;
  const id = new URLSearchParams(search).get('id');
  const [values, setValues] = useState({
    days_a_head: "4",
    advanced_day: "0",
    same_day_booking: true,
    booking_open_days_before: "3",
    booking_open_time: "18:00",
    max_future_bookings_per_unit: "3",
    max_daily_bookings_per_user: "2",
    booking_limit_group: null,
    booking_limit_group_id: null,
    booking_limit_group_name: "",
  });

  useEffect(() => {
    if (!id) return;
    AmenitiesService.getAmenityInfo(id)
      .then((res) => {

        const data = res.data;
        const newValues = {
          id: data.id,
          amenityName: data.name || "",
          name: data.name || "",
          description: data.description || "",
          price: data.price?.toString() || "0",
          is_free: data.price === 0,
          unit: data.currency || "CAD",
          capacity: data.all_capacity?.toString() || "0",
          minors: data.minors_count?.toString() || "0",
          guests: data.guests_count?.toString() || "0",
          duration: data.period_duration ? `${data.period_duration} Minutes` : "10 Minutes",
          gap: data.gap_duration ? `${data.gap_duration} Minutes` : "5 Minutes",
          category: data.amenity_type || null,
          shared_resource: data.shared_resource_id ? data.shared_resource : null,
          booking_limit_group: data.booking_limit_group_id ? data.booking_limit_group : null,
          booking_limit_group_id: data.booking_limit_group_id || null,
          booking_limit_group_name: data.booking_limit_group?.name || "",
          shared_resource_id: data.shared_resource_id || null,
          shared_resource_name: data.shared_resource?.name || "",
          shared_resource_capacity: data.shared_resource?.capacity ? data.shared_resource.capacity.toString() : "",
          resource_layout: data.resource_layout || "",
          resource_capacity_units: data.resource_capacity_units ? data.resource_capacity_units.toString() : "",
          image: data.image || "",
          days_a_head: String(data.number_of_head_show ?? "0"),
          booking_open_days_before: String(data.booking_open_days_before ?? "3"),
          booking_open_time: data.booking_open_time ?? "18:00",
          max_future_bookings_per_unit: String(data.booking_limit_group_id ? data.booking_limit_group.max_future_bookings_per_unit : data.max_future_bookings_per_unit ?? "3"),
          max_daily_bookings_per_user: String(data.booking_limit_group_id ? data.booking_limit_group.max_daily_bookings_per_user : data.max_daily_bookings_per_user ?? "2"),
          advanced_day: data.same_day_booking
            ? "0"
            : String(data.booking_advance_days ?? "0") === "0"
              ? "1"
              : String(data.booking_advance_days ?? "0"),
          same_day_booking: data.same_day_booking || false,
          operation_days: data.operation_days || [],
          dates: data.dates || [],
          questions: (data.questions || []).map((q) => ({
            id: q.id,
            question_text: q.question_text,
            correct_answer: q.correct_answered ? "yes" : "no",
          })),
        };

        console.log("newValues:", newValues);
        (data.operation_days || []).forEach((d) => {

          const day = d.week_day_name?.toLowerCase();

          if (!day) return;

          if (day === "holiday") {
            newValues.start_holiday = d.start_time || "";
            newValues.end_holiday = d.end_time || "";
            newValues.holiday = true;
          } else {

            newValues[`start_${day}`] = d.start_time || "";
            newValues[`end_${day}`] = d.end_time || "";

            newValues[day] = true;
          }

        });

        
        setValues(newValues);

      })
      .catch((err) => {
        console.log("API ERROR:", err);
      });

  }, [id]);


  const [validStep, setValidStep] = useState(false);
  const [uniqueId, setUniqueId] = useState(uuidv4().toString());
  const [infoSB, setInfoSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const [errorMessage, SetErrorMessage] = useState("");
  const maxAmenityImageSize = 1024 * 1024;
  const allowedAmenityImageTypes = ["image/jpeg", "image/png", "image/gif"];
  const allowedAmenityImageExtensions = [".jpg", ".jpeg", ".png", ".gif"];

  const validateAmenityImage = (image) => {
    if (!(image instanceof File)) return "";

    const fileName = image.name?.toLowerCase() || "";
    const hasValidExtension = allowedAmenityImageExtensions.some((extension) => fileName.endsWith(extension));

    if (!allowedAmenityImageTypes.includes(image.type) && !hasValidExtension) {
      return "Image file is not valid. Please use JPG, JPEG, PNG, or GIF.";
    }

    if (image.size > maxAmenityImageSize) {
      return "Image is too large. Maximum allowed size is 1 MB.";
    }

    return "";
  };

  const getApiErrorMessage = (error, fallback = "Something went wrong") => {
    const data = error?.response?.data;
    const status = error?.response?.status;

    if (status === 413) return "Image is too large. Maximum allowed size is 1 MB.";
    if (typeof data === "string") return data;
    if (typeof data?.status === "string") return data.status;
    if (typeof data?.message === "string") return data.message;
    if (typeof error?.message === "string") return error.message;

    return fallback;
  };

  const showError = (error, fallback) => {
    SetErrorMessage(getApiErrorMessage(error, fallback));
    setErrorSB(true);
  };

  const deleteCreatedAmenity = (amenityId) => {
    if (!amenityId) return Promise.resolve();
    return AmenitiesService.deleteAmenity(amenityId).catch(() => {});
  };

  // console.log(uniqueId);
  const renderSB = (
    <div>
      <MDSnackbar
        color="success"
        icon="notifications"
        title="Amenity System"
        content="Your data saved successfully"
        dateTime=""
        open={infoSB}
        onClose={() => setInfoSB(false)}
        close={() => setInfoSB(false)} />

      <MDSnackbar
        color="error"
        icon="error"
        title="Amenity System"
        content={errorMessage}
        dateTime=""
        open={errorSB}
        onClose={() => setErrorSB(false)}
        close={() => setErrorSB(false)} />
    </div>
  );
  const [activeLoading, setActiveLoading] = useState(false);

  console.log(values);


  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return <AmenityInfo key={`info-${values.id || id || "new"}`} validStep={setValidStep} uniqueId={uniqueId} valueSetter={setValues} oldValues={values} />;
      case 1:
        return <AmenityMedia key={`media-${values.id || id || "new"}`} validStep={setValidStep} uniqueId={uniqueId} valueSetter={setValues} oldValues={values} />;
      case 2:
        return <AmenityPricing key={`pricing-${values.id || id || "new"}`} validStep={setValidStep} uniqueId={uniqueId} valueSetter={setValues} oldValues={values} />;
      case 3:
        return <AmenityTimingWeekDay key={`weekday-${values.id || id || "new"}`} validStep={setValidStep} uniqueId={uniqueId} valueSetter={setValues} oldValues={values} />;
      case 4:
        return <AmenityTiming key={`timing-${values.id || id || "new"}`} validStep={setValidStep} uniqueId={uniqueId} valueSetter={setValues} oldValues={values} />;
      case 5:
        return <AmenityQuestions key={`questions-${values.id || id || "new"}`} validStep={setValidStep} uniqueId={uniqueId} valueSetter={setValues} oldValues={values} />;
      // case 6:
      //   return <AmenityAds />;
      // case 6:
      //   return <AmenityInsertReview  validStep={setValidStep} uniqueId={uniqueId} valueSetter={setValues} oldValues={values} />;
      default:
        return null;
    }
  }

  // console.log(values)
  // console.log("fromParent -> " + validStep);

  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const isLastStep = activeStep === steps.length - 1;

  const handleFinish = () => {
    console.log("VALUES STATE:", values);
    console.log("AMENITY NAME VALUE:", values.amenityName);

    const isEditing = id !== null && id !== undefined && id !== "0";
    const imageValidationMessage = validateAmenityImage(values.image);

    if (imageValidationMessage) {
      SetErrorMessage(imageValidationMessage);
      setErrorSB(true);
      return;
    }

    const payload = {
      ...values,
      id: values.id || id,
      amenityName: values.amenityName || values.name || "",
      price: values.price?.toString()
    };

    console.log("PAYLOAD BEFORE SEND:", payload);

    delete payload.amenity_operation_days;

    console.log("========= FRONTEND SEND =========");
    console.log("VALUES STATE:", values);


    const data = {
      amenityName: values.amenityName || "",
      minors: values.minors || "0",
      guests: values.guests || "0",
      duration: typeof values.duration === "string" ? values.duration.split(" ")[0] : `${values.duration || 0}`,
      gap: typeof values.gap === "string" ? values.gap.split(" ")[0] : `${values.gap || 0}`,
      capacity: values.capacity || "0",
      shared_resource_id: values.shared_resource_id || values.shared_resource?.id || null,
      booking_limit_group_id: values.booking_limit_group_id || values.booking_limit_group?.id || null,
      shared_resource_name: values.shared_resource_name || values.shared_resource?.name || "",
      shared_resource_capacity: values.shared_resource_capacity || "",
      resource_layout: values.resource_layout || "",
      resource_capacity_units: values.resource_capacity_units || "",
      category: values.category || { id: 0 },
      subCategory: values.subCategory || "",
      description: values.description || "",
      price: values.price?.toString() || "0",
      unit: values.unit || "CAD",
      days_a_head: values.days_a_head,
      booking_advance_days:
        (typeof values.same_day_booking === "boolean"
          ? values.same_day_booking
          : String(values.same_day_booking).toLowerCase() === "true")
          ? "0"
          : values.advanced_day === "0" ? "1" : values.advanced_day || "1",
      start_saturday: values.start_saturday || "",
      end_saturday: values.end_saturday || "",
      start_sunday: values.start_sunday || "",
      end_sunday: values.end_sunday || "",
      start_monday: values.start_monday || "",
      end_monday: values.end_monday || "",
      start_tuesday: values.start_tuesday || "",
      end_tuesday: values.end_tuesday || "",
      start_wednesday: values.start_wednesday || "",
      end_wednesday: values.end_wednesday || "",
      start_thursday: values.start_thursday || "",
      end_thursday: values.end_thursday || "",
      start_friday: values.start_friday || "",
      end_friday: values.end_friday || "",
      start_holiday: values.start_holiday || "",
      end_holiday: values.end_holiday || "",

      days_a_head: values.days_a_head || values.number_of_head_show?.toString() || "0",      
      booking_open_days_before: values.booking_open_days_before ?? "3",
      booking_open_time: values.booking_open_time ?? "18:00",
      max_future_bookings_per_unit: values.max_future_bookings_per_unit ?? "3",
      max_daily_bookings_per_user: values.max_daily_bookings_per_user ?? "2",
      same_day_booking:
        typeof values.same_day_booking === "boolean"
          ? values.same_day_booking
          : String(values.same_day_booking).toLowerCase() === "true",

      questions: values.questions || [],
    };


    console.log("FINAL PAYLOAD:", data);
    console.log("=================================");
    const apiCall = isEditing
      ? AmenitiesService.updateAmenity(values.id || id, data)
      : AmenitiesService.insertAmenity(data);

    apiCall
      .then((response) => {
        if (values.image !== undefined && values.image !== null && values.image instanceof File) {
          let fd = new FormData();
          fd.append("image", values.image, values.image.name);
          fd.append("id", response.data.id);
          AmenitiesService.uploadImage(fd)
            .then((data) => {
              setInfoSB(true);
              setActiveLoading(false);
              window.location = "/amenities";
            }).catch((res) => {
              deleteCreatedAmenity(!isEditing ? response.data.id : null)
                .finally(() => showError(res, "Image upload failed"));
              setActiveLoading(false);
            });
        } else {
          // No new image to upload, redirect immediately
          setInfoSB(true);
          setActiveLoading(false);
          window.location = "/amenities";
        }
      }).catch((reason) => {
        showError(reason, "Amenity could not be saved");
        setActiveLoading(false);
      });
  };
  const hasAnyWeekdayTime = () => {
    const days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday", "holiday"];

    return days.some((day) => values[`start_${day}`] && values[`end_${day}`]);
  };

  const handleNext = () => {
    if (activeStep === 3 && !hasAnyWeekdayTime()) {
      SetErrorMessage("Please set start and end time for at least one day.");
      setErrorSB(true);
      return;
    }

    setActiveStep(activeStep + 1);
  };
  const handleBack = () => setActiveStep(activeStep - 1);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {renderSB}

      <MDBox mb={12}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={11}>
            <MDBox mt={6} mb={8} textAlign="center">
              <MDBox mb={1}>
                <MDTypography variant="h2" fontWeight="bold">
                  {(id > 0 ? `Edit Amenity: ${values.amenityName || values.name || ""}` : "Add New Amenity")}
                </MDTypography>
              </MDBox>
              <MDTypography variant="h3" fontWeight="regular" color="secondary">
                This information will describe more about the amenity.
              </MDTypography>
            </MDBox>
            <Card>
              <MDBox mt={-3} mb={3} mx={2}>
                <Stepper activeStep={activeStep} alternativeLabel >
                  {steps.map((label) => (
                    <Step key={label} >
                      <StepLabel  >{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </MDBox>
              <MDBox p={2}>
                <MDBox>
                  {getStepContent(activeStep)}
                  <MDBox mt={3} width="100%" display="flex" justifyContent="space-between">
                    {activeStep === 0 ? (
                      <MDBox />
                    ) : (
                      <MDButton variant="gradient" color="light" onClick={handleBack}>
                        back
                      </MDButton>
                    )}
                    <MDButton
                      variant="gradient"
                      color="success"
                      size="large"
                      disabled={!validStep}
                      onClick={!isLastStep ? handleNext : handleFinish}
                    >
                      {isLastStep ? "Save And Confirm" : "Next Step"}
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default InsertAmenity;
